import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import ImageProfil from "../Profil/ImageProfil";
import { DateParser } from "../utils/Utils";
import KnowledgeStatus from "./KnowledgeStatus";
import RequestStatusBadge from "./RequestStatusBadge";

// Liste d'accordéons réutilisée par les pages Assignées / Terminées / Annulées.
const RequestKnowledgeList = ({ requests, emptyLabel, pageSize = 8 }) => {
  const [openId, setOpenId] = useState(null);
  const [limit, setLimit] = useState(pageSize);

  if (!requests.length) {
    return <div className="req-empty">{emptyLabel}</div>;
  }

  const visible = requests.slice(0, limit);

  return (
    <>
      <div className="req-list">
        {visible.map((request) => {
          const open = openId === request.id;
          const referent = request?.referent;
          return (
            <div className={`req-card ${open ? "is-open" : ""}`} key={request.id}>
              <button
                type="button"
                className="req-card-head"
                onClick={() => setOpenId(open ? null : request.id)}
              >
                <div className="req-card-user">
                  <ImageProfil id={request?.user?.id} />
                  <div className="req-card-user-meta">
                    <span className="req-card-name">
                      {request?.user?.firstname} {request?.user?.name}
                    </span>
                    <span className="req-card-sub">
                      Réf. :{" "}
                      {referent
                        ? `${referent.firstname} ${referent.name}`
                        : "non assigné"}
                    </span>
                  </div>
                </div>
                <span className="req-chip">{request?.nature}</span>
                <span className="req-cat">{request?.categorie}</span>
                <span className="req-date">{DateParser(request?.createdAt)}</span>
                <RequestStatusBadge status={request?.requestStatus} />
                <ChevronDown size={18} className="req-card-chevron" />
              </button>
              {open && (
                <div className="req-card-body">
                  <p className="req-card-demande">
                    <span>Demande</span>
                    {request?.texte}
                  </p>
                  <KnowledgeStatus knowledge={request} />
                </div>
              )}
            </div>
          );
        })}
      </div>
      {limit < requests.length && (
        <div className="req-more">
          <button
            className="ds-btn ds-btn--ghost"
            onClick={() => setLimit(limit + pageSize)}
          >
            Voir plus
          </button>
        </div>
      )}
    </>
  );
};

export default RequestKnowledgeList;
